import axios from "axios";
import {
  SET_LOADER_SECONDARY,
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_MULTIPLE_CHAT_INFO,
  GET_CHAT_INFO,
  GET_ADMIN_CHAT_INFO,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - SEND NOTIFICATION ACTION
 *****************************************/
export const send_notification_diner =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let send_notification_diner = await axios.post(
        `${serverApi}/vendor/notifications`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (send_notification_diner.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        Alert.success(`<h4>Notification Send Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const send_sms_diner =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let send_sms_diner = await axios.post(
        `${serverApi}/vendor/notifications`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (send_sms_diner.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        Alert.success(`<h4>SMS Send Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_chat_vendor_user =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let create_chat_vendor_user = await axios.post(
        `${serverApi}/chat`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (create_chat_vendor_user.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess(create_chat_vendor_user.data);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_admin_chat_vendor_user =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let create_chat_vendor_user = await axios.post(
        `${serverApi}/chat`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (create_chat_vendor_user.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess(create_chat_vendor_user.data);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_multiple_chat_vendor_user =
  (vendorId, token) => async (dispatch) => {
    // dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let get_multi_chat_vendor_user = await axios.get(
        `${serverApi}/chat?vendor=${vendorId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_multi_chat_vendor_user.status === 200) {
        dispatch({
          type: GET_MULTIPLE_CHAT_INFO,
          payload: get_multi_chat_vendor_user.data,
        });
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      // dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_single_chat_vendor_user =
  (query, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: GET_CHAT_INFO, payload: { messages: [] } });
    // dispatch({ type: SET_LOADER });
    try {
      let create_chat_vendor_user = await axios.get(`${serverApi}/chat`, {
        params: query,
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (create_chat_vendor_user.status === 200) {
        if (create_chat_vendor_user.data[0] === undefined) {
        } else {
          dispatch({
            type: GET_CHAT_INFO,
            payload: create_chat_vendor_user.data[0],
          });
        }
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_single_admin_chat_vendor =
  (token, vendorId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: GET_ADMIN_CHAT_INFO, payload: { messages: [] } });
    // query,
    // dispatch({ type: SET_LOADER });
    try {
      let create_chat_vendor_user = await axios.get(
        `${serverApi}/chat?vendor=${vendorId}&type=GENERAL`,
        {
          // params: query,
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (create_chat_vendor_user.status === 200) {
        if (create_chat_vendor_user.data[0] === undefined) {
        } else {
          dispatch({
            type: GET_ADMIN_CHAT_INFO,
            payload: create_chat_vendor_user.data[0],
          });
        }
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_single_admin_chat_user =
  (token, userId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: GET_ADMIN_CHAT_INFO, payload: { messages: [] } });
    // query,
    // dispatch({ type: SET_LOADER });
    try {
      let create_chat_vendor_user = await axios.get(
        `${serverApi}/chat?user=${userId}&type=USER_GENERAL`,
        {
          // params: query,
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (create_chat_vendor_user.status === 200) {
        if (create_chat_vendor_user.data[0] === undefined) {
        } else {
          dispatch({
            type: GET_ADMIN_CHAT_INFO,
            payload: create_chat_vendor_user.data[0],
          });
        }
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_mark_all_chat_vendor_user =
  (formData, token, onMarkCompletedSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_chat_vendor_user = await axios.patch(
        `${serverApi}/chat`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_chat_vendor_user.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onMarkCompletedSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
